const lang = {
    ja: {
        'visitHistoryManagement.exhibitionVisit': '展示会閲覧履歴',
        'visitHistoryManagement.seminarVisit': 'セミナー受講閲覧履歴',
        'visitHistoryManagement.seminarSubject': 'セミナー課題',
        'visitHistoryManagement.seminarDateTime': '申込日時',
        'visitHistoryManagement.orderProductGrandBooth': '商品注文履歴',
        'visitHistoryManagement.liveStreamVisit': 'ライブ配信申込み履歴',
    },
};

export default lang;
